import process from 'node:process';
import z from 'zod';

const testOverridesSchema = z.object({
  biLoggerBaseUrl: z.string().url().optional(),
  devEditorBaseUrl: z.string().url().optional(),
  inkDebug: z.boolean().optional(),
  retries: z.number().optional(),
  minRetryTimeout: z.number().optional(),
  pollInterval: z.number().optional(),
  pollTimeout: z.number().optional(),
  debounceQueueWait: z.number().optional(),
  sentryDsn: z.string().optional(),
  userBrowserTestEndpoint: z.string().url().optional(),
  dataDir: z.string().optional(),
  wixCliDependencyVersion: z.string().optional(),
  wixCliAppDependencyVersion: z.string().optional(),
  disableTTY: z.boolean().optional(),
  disableStdoutTTY: z.boolean().optional(),
  disableStderrTTY: z.boolean().optional(),
  loginWithDeviceCodeInterval: z.number().optional(),
  registryUrl: z.string().optional(),
  fsCacheDir: z.string().optional(),
  localTunnel: z.boolean().optional(),
  customElementsCreationDelay: z.number().optional(),
  sdkAuthServerBaseUrl: z.string().optional(),
  miniflareRequestsRewrites: z
    .array(z.object({ from: z.string(), to: z.string() }))
    .optional(),
  panoramaReporterUrl: z.string().optional(),
  isCI: z.boolean().optional(),
  isPR: z.boolean().optional(),
  ciName: z.string().optional(),
  cliEnvName: z.string().optional(),
  cliTrackingId: z.string().optional(),
});

export type CLITestOverrides = z.infer<typeof testOverridesSchema>;

export const TEST_OVERRIDES_ENV_VAR = 'WIX_CLI_TEST_OVERRIDES';

export function getTestOverrides(): CLITestOverrides {
  const rawOverrides = process.env[TEST_OVERRIDES_ENV_VAR];

  if (!rawOverrides) {
    return {};
  }

  return testOverridesSchema.parse(JSON.parse(rawOverrides));
}

export function isTestEnv(): boolean {
  return !!process.env[TEST_OVERRIDES_ENV_VAR];
}

export function setupTestEnv(): void {
  if (isTestEnv()) {
    // See https://github.com/wix-private/wix-cli/pull/814
    process.stdout.columns = 300;
    process.stderr.columns = 300;

    const { disableTTY, disableStdoutTTY, disableStderrTTY } =
      getTestOverrides();
    process.stdin.isTTY = !disableTTY;

    if (disableStderrTTY !== undefined) {
      process.stderr.isTTY = !disableStderrTTY;
    }
    if (disableStdoutTTY !== undefined) {
      process.stdout.isTTY = !disableStdoutTTY;
    }
    process.stdin.setRawMode = () => process.stdin;
  }
}
